import { render, staticRenderFns } from "./VatChecker.vue?vue&type=template&id=5d52047c&"
import script from "./VatChecker.vue?vue&type=script&lang=js&"
export * from "./VatChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d52047c')) {
      api.createRecord('5d52047c', component.options)
    } else {
      api.reload('5d52047c', component.options)
    }
    module.hot.accept("./VatChecker.vue?vue&type=template&id=5d52047c&", function () {
      api.rerender('5d52047c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VatChecker.vue"
export default component.exports